import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  getMyPage,
  changePicture,
  clientSearchByName,
  clientGetPage,
  getMyUserGroupPage,
  analyzeVehicleLicensePicture,
  changeBusinessUser,
} from '@/api/transportvehicleinfoserv'

export default {
  state: {
    state_TransportVehicleInfo_GetAllResult: null,
    state_TransportVehicleInfo_SearchByNameResult: null,
    state_TransportVehicleInfo_GetPageResult: null,
    state_TransportVehicleInfo_GetDetailResult: null,
    state_TransportVehicleInfo_AddObjResult: null,
    state_TransportVehicleInfo_ModifyObjResult: null,
    state_TransportVehicleInfo_DeleteObjResult: null,
    state_TransportVehicleInfo_GetMyPageResult: null,
    state_TransportVehicleInfo_ChangePictureResult: null,
    state_TransportVehicleInfo_ClientSearchByNameResult: null,
    state_TransportVehicleInfo_ClientGetPageResult: null,
    state_TransportVehicleInfo_GetMyUserGroupPageResult: null,
    state_TransportVehicleInfo_AnalyzeVehicleLicensePictureResult: null,
    state_TransportVehicleInfo_ChangeBusinessUserResult: null,
  },
  mutations: {
    SET_TRANSPORTVEHICLEINFO_GETALL_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_GetAllResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_SearchByNameResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_GETPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_GetPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_GETDETAIL_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_GetDetailResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_ADDOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_AddObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_ModifyObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_DELETEOBJ_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_DeleteObjResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_GETMYPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_GetMyPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_CHANGEPICTURE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_ChangePictureResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_CLIENTSEARCHBYNAME_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_ClientSearchByNameResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_CLIENTGETPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_ClientGetPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_GetMyUserGroupPageResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_AnalyzeVehicleLicensePictureResult = rst;
    },
    SET_TRANSPORTVEHICLEINFO_CHANGEBUSINESSUSER_RESULT: (state, rst) => {
      state.state_TransportVehicleInfo_ChangeBusinessUserResult = rst;
    },
  },
  actions: {
    TransportVehicleInfoServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_ChangePicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changePicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_CHANGEPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_CHANGEPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_ClientSearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientSearchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_CLIENTSEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_CLIENTSEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_ClientGetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        clientGetPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_CLIENTGETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_CLIENTGETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_GetMyUserGroupPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_GETMYUSERGROUPPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_GETMYUSERGROUPPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_AnalyzeVehicleLicensePicture({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        analyzeVehicleLicensePicture(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_ANALYZEVEHICLELICENSEPICTURE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    TransportVehicleInfoServ_ChangeBusinessUser({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        changeBusinessUser(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_TRANSPORTVEHICLEINFO_CHANGEBUSINESSUSER_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_TRANSPORTVEHICLEINFO_CHANGEBUSINESSUSER_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_TransportVehicleInfo_GetAllResult: state => {
      return state.state_TransportVehicleInfo_GetAllResult;
    },
    get_TransportVehicleInfo_SearchByNameResult: state => {
      return state.state_TransportVehicleInfo_SearchByNameResult;
    },
    get_TransportVehicleInfo_GetPageResult: state => {
      return state.state_TransportVehicleInfo_GetPageResult;
    },
    get_TransportVehicleInfo_GetDetailResult: state => {
      return state.state_TransportVehicleInfo_GetDetailResult;
    },
    get_TransportVehicleInfo_AddObjResult: state => {
      return state.state_TransportVehicleInfo_AddObjResult;
    },
    get_TransportVehicleInfo_ModifyObjResult: state => {
      return state.state_TransportVehicleInfo_ModifyObjResult;
    },
    get_TransportVehicleInfo_DeleteObjResult: state => {
      return state.state_TransportVehicleInfo_DeleteObjResult;
    },
    get_TransportVehicleInfo_GetMyPageResult: state => {
      return state.state_TransportVehicleInfo_GetMyPageResult;
    },
    get_TransportVehicleInfo_ChangePictureResult: state => {
      return state.state_TransportVehicleInfo_ChangePictureResult;
    },
    get_TransportVehicleInfo_ClientSearchByNameResult: state => {
      return state.state_TransportVehicleInfo_ClientSearchByNameResult;
    },
    get_TransportVehicleInfo_ClientGetPageResult: state => {
      return state.state_TransportVehicleInfo_ClientGetPageResult;
    },
    get_TransportVehicleInfo_GetMyUserGroupPageResult: state => {
      return state.state_TransportVehicleInfo_GetMyUserGroupPageResult;
    },
    get_TransportVehicleInfo_AnalyzeVehicleLicensePictureResult: state => {
      return state.state_TransportVehicleInfo_AnalyzeVehicleLicensePictureResult;
    },
    get_TransportVehicleInfo_ChangeBusinessUserResult: state => {
      return state.state_TransportVehicleInfo_ChangeBusinessUserResult;
    },
  }
}